export function getRouteLocale(route = null) {
  const routeLocale = Array.isArray(route?.params?.locale) ? route.params.locale[0] : route?.params?.locale;
  if (routeLocale) return routeLocale;

  const storedLocale = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null;
  return storedLocale || process.env.VUE_APP_I18N_LOCALE || 'ru';
}

export function getLoginRoute(route = null) {
  return {
    name: 'login',
    params: { locale: getRouteLocale(route) },
    replace: true,
  };
}

export function redirectToLogin(router, route = null) {
  const loginRoute = getLoginRoute(route || router?.currentRoute?.value);

  if (router?.push) {
    return router.push(loginRoute);
  }

  if (typeof window !== 'undefined') {
    window.location.href = `/${loginRoute.params.locale}/login`;
  }

  return undefined;
}
